import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";

export function isSpdr(
  spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel | undefined
) {
  if (!spdrOrPdsr) {
    return false;
  }
  return "SpdrId" in spdrOrPdsr;
}
